import { useMemo } from 'react';

import { formatDate, isPastDate } from '@xemplo/date-time';
import { FUTURE_SCHEDULED_PAYRUN } from '@xemplo/gp-constants';
import { PayrunSteps } from '@xemplo/gp-types';
import { getStepStatusIds } from '@xemplo/gp-utils';
import { useGetPayrunListQuery } from '@xemplo/payrun-query';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V2 } from '@xemplo/text-dropdown';

import * as S from '../../modal.styles';

export function SelectPayrun() {
  const { data: payrunList, isLoading } = useGetPayrunListQuery({
    requestParams: {
      filter: { statusIds: getStepStatusIds(PayrunSteps.Submit) },
      per_page: 1000,
    },
  });

  const parsedData = useMemo(() => {
    const filteredList =
      payrunList?.result?.rows
        ?.filter((item) => !isPastDate(item.amendmentDueDateTime))
        .map((item) => ({
          key: item.id,
          value: `${item.name} (Pay Cycle: ${formatDate({
            value: item.payCycleStartDate,
          })} - ${formatDate({ value: item.payCycleEndDate })})`,
        })) ?? [];
    return [...filteredList, { key: FUTURE_SCHEDULED_PAYRUN, value: 'Future payrun' }];
  }, [payrunList]);

  const payrunList_ = useListBuilder(parsedData);

  return (
    <S.FormLabel>
      Select pay run
      <V2.TextDropdownRhf
        name="payrun"
        items={payrunList_}
        placeholder="Select pay run"
        aria-label="Select pay run"
        disabled={isLoading}
        searchable
        rules={{ required: 'This field is required' }}
      />
    </S.FormLabel>
  );
}
